import { useMediaQuery } from '@mui/material';
import BudgetSummaryMobile from './mobile/BudgetSummaryMobile';

interface IBudgetSummaryProps {
  subtotal?: number;
  discounts?: number;
  subscriptionBalanceApplied?: number;
  totalToPay?: number;
  counterProposalValue?: number;
  counterProposalAcceptedAt?: string | null;
}

const formatCurrencyDisplay = (value: number | undefined): string => {
  if (value === undefined || value === null || value === 0) {
    return 'R$ 00,00';
  }

  const reais = Math.floor(value);
  const centavos = Math.round((value - reais) * 100);

  const formattedReais = reais.toLocaleString('pt-BR');
  const formattedCentavos = String(centavos).padStart(2, '0');

  return `R$ ${formattedReais},${formattedCentavos}`;
};

const BudgetSummary = (props: IBudgetSummaryProps) => {
  const isMobile = useMediaQuery('(max-width: 768px)');
  
  if (isMobile) {
    return (
      <BudgetSummaryMobile
        subtotal={props.subtotal}
        discounts={props.discounts}
        subscriptionBalanceApplied={props.subscriptionBalanceApplied}
        totalToPay={props.totalToPay}
        counterProposalValue={props.counterProposalValue}
        counterProposalAcceptedAt={props.counterProposalAcceptedAt}
      />
    );
  }
  
  return (
    <div className="text-right border border-gray-200 dark:border-neutral-700 rounded-md p-4">
      <div className="flex flex-col gap-3">
        <div className="text-size-16 mb-1 text-gray-500 dark:text-neutral-400">
          Subtotal: {formatCurrencyDisplay(props.subtotal)}
        </div>
        <div className="text-size-18 mb-1 text-green-500 dark:text-green-400">
          Descontos: {formatCurrencyDisplay(props.discounts)}
        </div>
        {props.subscriptionBalanceApplied ? <div className="text-size-18 mb-1 text-green-500 dark:text-green-400">
          Saldo do plano utilizado: {formatCurrencyDisplay(props.subscriptionBalanceApplied)}
        </div> : null}
        <div className={`text-size-18 font-bold mb-1 text-gray-900 dark:text-neutral-100 ${props.counterProposalAcceptedAt ? 'line-through' : ''}`}>
          Valor a ser pago: {formatCurrencyDisplay(props.totalToPay)}
        </div>
        {props.counterProposalAcceptedAt && (
          <div className="text-size-18 font-bold mb-4 text-gray-900 dark:text-neutral-100">
            Valor a ser pago: {formatCurrencyDisplay(props.counterProposalValue)}
          </div>
        )}
      </div>
    </div>
  );
};

export default BudgetSummary;

